// extracted by mini-css-extract-plugin
export default {"root":"CWYUE","content":"Y8klu","loading":"YyhgV","loader":"VYtSD"};